import { Button } from '@src/design-system/button';
import { useNotificationRead } from '../hooks/use-notification-read';
import { cn } from '@src/design-system/helpers';

export const NotificationReadAll = ({ className }: { className?: string }) => {
  const { handleAllAsRead } = useNotificationRead();
  return (
    <Button
      className={cn(
        'hidden sm:inline-block bg-transparent hover:bg-transparent text-ms font-medium p-0 h-auto ml-auto text-[#5B31AA] !underline',
        className
      )}
      onClick={handleAllAsRead}
    >
      Mark All As Read
    </Button>
  );
};
